module.exports = function(vars) {
var __t, __p = '';
__p += '<li class="broadcast-item">\n		<span class="broadcast-title">None Scheduled <i class="fa fa-frown-o"></i></span>\n</li>\n';
return __p
}


// WEBPACK FOOTER //
// ./src/templates/no-broadcast-list-item.ejs